<div class="control">
  <label for="image-input" class="full-width">
    {{ label }}
  </label>

  <div class="image" *ngIf="!imagePath">
    <div
      class="file is-large"
      [ngClass]="{
        'is-invalid': !imagePath
      }"
    >
      <label class="image-label">
        <!-- Input element -->
        <input
          id="image-input"
          class="file-input"
          type="file"
          accept="image/*"
          #imageInput
          [placeholder]="placeholder"
          (change)="imageInputEvent($event)"
        />
        <span class="file-cta" *ngIf="!loading">
          <span class="file-icon">
            <i class="fas fa-download"></i>
          </span>
          <span class="file-label">
            {{ placeholder }}
          </span>
        </span>

        <button class="button is-link is-loading full-width" *ngIf="loading">
          Chagement
        </button>
      </label>
    </div>
  </div>

  <!-- Previously uploaded file -->
  <div
    *ngIf="imagePath"
    class="has-current-file is-flex is-align-items-center is-justify-content-space-between mt-1 has-background-white-ter pl-1"
  >
    <img
      [src]="imagePath"
      alt="Uploaded image"
      class="py-1 is-block"
      width="46"
    />
    <span class="file-cta file-remove">
      <a (click)="removeFile()" (keydown)="removeFile()" tabindex="0">
        <i class="fa fa-times is-size-5"></i>
      </a>
    </span>
  </div>
  <p class="help" *ngIf="helpText">{{ helpText }}</p>
</div>
